import axios from 'axios';
import { APP_CONFIG } from '@/config/app-config';
import authProvider from '@/utility/authProvider';

export default class HttpClient {
    public static instance() {
        const baseURL = `${APP_CONFIG.system_type === 'order' ? APP_CONFIG.baseDomain : APP_CONFIG.baseDomainDeposit}/client`;
        const httpClient = axios.create({
            baseURL,
            headers: authProvider.isToken() ? {'Authorization': `Bearer ${authProvider.getToken()}` } : null,
        });
        httpClient.interceptors.request.use(
            (requestConfig) => {
                // if(authProvider.isToken()) {
                //     requestConfig.headers.Authorization = `Bearer ${authProvider.getToken()}`;
                // }
                return requestConfig;
            },
            (requestError) => {
                // requestError.data = null;
                // return Promise.resolve(requestError);
            },
        );
        httpClient.interceptors.response.use(
            (response) => {
                return response;
            },
            (error) => {
                // error.data = null;
                // return Promise.resolve(error);
            },
        );

        return httpClient;
    }
}